import { AxiosResponse } from "axios";

// Models
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

export abstract class IQuoteImageApi {
	abstract getDownloadImage(guidFile: string): Promise<AxiosResponse<Result<KeyValue>>>;
}
